var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCirclePass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83268 12.8337L13.7077 6.95866L12.541 5.79199L7.83268 10.5003L5.45768 8.12533L4.29102 9.29199L7.83268 12.8337ZM8.99935 17.3337C7.84657 17.3337 6.76324 17.1149 5.74935 16.6774C4.73546 16.2399 3.85352 15.6462 3.10352 14.8962C2.35352 14.1462 1.75977 13.2642 1.32227 12.2503C0.884766 11.2364 0.666016 10.1531 0.666016 9.00033C0.666016 7.84755 0.884766 6.76421 1.32227 5.75033C1.75977 4.73644 2.35352 3.85449 3.10352 3.10449C3.85352 2.35449 4.73546 1.76074 5.74935 1.32324C6.76324 0.885742 7.84657 0.666992 8.99935 0.666992C10.1521 0.666992 11.2355 0.885742 12.2493 1.32324C13.2632 1.76074 14.1452 2.35449 14.8952 3.10449C15.6452 3.85449 16.2389 4.73644 16.6764 5.75033C17.1139 6.76421 17.3327 7.84755 17.3327 9.00033C17.3327 10.1531 17.1139 11.2364 16.6764 12.2503C16.2389 13.2642 15.6452 14.1462 14.8952 14.8962C14.1452 15.6462 13.2632 16.2399 12.2493 16.6774C11.2355 17.1149 10.1521 17.3337 8.99935 17.3337Z",
    fill: "#00B768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePass);
export default __webpack_public_path__ + "static/media/CheckCirclePass.804f571451ec779a313c70389afe599f.svg";
export { ForwardRef as ReactComponent };